import React, { useEffect, useState } from "react";
import { Row,Col } from "reactstrap";
import useToken from "../../../helpers/useToken"
import TMHLoader from "../../TMHLoader/TMHLoader"
import ProcessedCodeTable from "./ProcessedCodeTable"
import AvailableCodeTable from "./AvailableCodeTable"
import OverView from "./RewardCodes";

export default function RewardCodesOverview({notify}) {
    const { token } = useToken()
    const [isLoading, setIsLoading] = useState(false)
    const [platforms, setPlatforms] = useState()

    useEffect(() => {
        const initData = async () => {

            console.log('RewardCodesOverview: update data')
            setIsLoading(true)
            var myHeaders = new Headers();
            myHeaders.append("Cache-Control", "no-cache");
            myHeaders.append("Access-Token", token);

            var requestOptions = {
                method: 'GET',
                headers: myHeaders,
            }

            fetch(process.env.REACT_APP_BASE_URL + "rewards/get_platforms", requestOptions)
                .then((response) => {
                    return new Promise((resolve) => response.json()
                        .then((json) => resolve({
                            status: response.status,
                            ok: response.ok,
                            json,
                        })))
                }).then(
                    (result) => {
                        var json = result.json
                        if (result.ok) {
                            setPlatforms(json.data)
                            setIsLoading(false)
                        }
                        else {
                            console.log(result.json)
                            setIsLoading(false)
                        }
                    }
                )
        }

        initData()
    }, [token])

    return (
        <TMHLoader active={isLoading}>
            {
                platforms && <Row>
                    <Col md="12">
                        <OverView notify={notify} platforms={platforms} setPlatforms={setPlatforms} />
                        <AvailableCodeTable notify={notify}  platforms={platforms} setPlatforms={setPlatforms} />
                        <ProcessedCodeTable platforms={platforms} />
                    </Col>
                </Row>
            }

        </TMHLoader>
    )
}